import { render, staticRenderFns } from "./TsStackedBarChart.vue?vue&type=template&id=12cd48e6&"
import script from "./TsStackedBarChart.vue?vue&type=script&lang=js&"
export * from "./TsStackedBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports